import { render, staticRenderFns } from "./StatusTable.vue?vue&type=template&id=31e7507a"
import script from "./StatusTable.vue?vue&type=script&lang=js"
export * from "./StatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports